export default function outsideClickListener(
  listening: boolean,
  setListening: (e: boolean) => void,
  menuRef: any,
  setIsOpen: (e: boolean) => void
) {
  return () => {
    if (listening) {
      return;
    }
    if (!menuRef.current) {
      return;
    }
    setListening(true);
    ['click', 'touchstart'].forEach(() => {
      document.addEventListener('click', (evt) => {
        const cur = menuRef.current;
        const node = evt.target;
        if (cur?.contains(node)) {
          return;
        }
        setIsOpen(false);
      });
    });
  };
}
